export interface OdometerValidationResult {
  isValid: boolean;
}

export function validateOdometerReading(
  odometerReading: number,
  lastKnownMileage: number,
  expirationMileage: number
): OdometerValidationResult {
  // Must be strictly greater than lastKnownMileage and less than or equal to expirationMileage (entering 0 or equal value is blocked)
  const isValid = odometerReading > 0 && odometerReading > lastKnownMileage && odometerReading <= expirationMileage;
  return { isValid };
}
